import type { StatusOption } from 'containers/Tasks/components/StatusPicker/StatusPicker';
import { colors } from 'theme/colors';
import { RiskActionStatus } from 'utils/api/modules/risks';

export const RISK_ACTION_STATUS_OPTIONS: StatusOption<RiskActionStatus>[] = [
  {
    value: RiskActionStatus.ToDo,
    label: 'To do',
    colors: { background: colors.tint.primary.medium, foreground: colors.common.black },
  },
  {
    value: RiskActionStatus.Done,
    label: 'Done',
    colors: { background: colors.ui.status.completed, foreground: colors.common.black },
  },
  {
    value: RiskActionStatus.Cancelled,
    label: 'Cancelled',
    colors: { background: colors.grey[600], foreground: colors.common.white },
  },
];

export const DEFAULT_STATUS_FILTER: RiskActionStatus[] = [RiskActionStatus.ToDo];
